import { FeatureUtil } from '@/utils/featureUtil';

// 更新指定键值，如果旧值存在options，则删除
function updateValue(target, key, newV = null) {
    const oldV = target[key];

    if (newV !== oldV) {
        target[key] = newV;
        if (oldV && typeof oldV === 'object' && 'options' in oldV) {
            delete oldV.options;
        }
    }
}

export default class PopupRequest {
    constructor() {
        this.isOpen = false;

        // slot定义
        this.default = null;

        // 要素
        this.feature = null;
        // 相关位置信息
        this.coord = null;
        this.offset = [0, 0];
        //映射字段
        this.fields = [];

        // 一个计数器，用于判断刷新逻辑
        this.popupCount = 0;
    }

    open(comp, { feature, coord, offset = [0, 0],fields=[] } = {}) {
        if (comp) {
            updateValue(this, 'default', comp);
            // 转为geojson
            this.feature = feature
                ? FeatureUtil.transform2GeoJson(feature, true)
                : null;

            // 坐标
            this.coord =
                coord || (feature ? FeatureUtil.getCenter(feature) : null);
            // offset信息
            this.offset = [...offset];
            this.fields = fields;
            
            // 添加coute
            this.popupCount++;
            this.isOpen = true;
        } else {
            throw '请提供正确渲染的模板！';
        }
    }

    hide(...rest) {
        // 关闭指定的模板
        if (rest.length) {
            if (rest.includes(this.default)) {
                this.popupCount--;
                this.isOpen = false;
            } else {
                return;
            }
        }

        this.popupCount--;
        this.isOpen = false;
    }

    reset() {
        updateValue(this, 'default');

        // 要素
        this.feature = null;
        this.fields = [];
        // 相关位置信息
        this.coord = null;
        this.offset = [0, 0];
    }
}
